import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { useFormat } from '../../../hooks/useFormat'

const HeroImage = ({ image, className, format }) => {
  const formatStyle = useFormat(format)
  if (image !== undefined) {
    return (
      <div className={`img-wrapper hero ${className} ${format.shadow && format.boundaries !== "full" ? "shadow" : ""}`} style={formatStyle}>

        <GatsbyImage
          objectFit="cover"
          image={image.gatsbyImageData}
          alt=""
        />
      </div>
    )
  } else {
    return <div />
  }
}

export default HeroImage

// export const query = graphql`
//   fragment AhoyImage on File {
//     childImageSharp {
//       gatsbyImageData (
//         layout: FULL_WIDTH
//         transformOptions: {fit: COVER}
//       )
//     }
//   }
// `

export const query = graphql`
  fragment AhoyImage on File {
    childImageSharp {
      gatsbyImageData (
        layout: FULL_WIDTH
        placeholder:BLURRED
        breakpoints: [750, 1080, 1366, 1920, 2160, 2560, 4000]
        transformOptions: {fit: COVER}
        quality: 70 
      )
    }
  }
`